import { NgModule } from '@angular/core';
import { MatTreeModule } from '@angular/material/tree';
import { NgxMatDatetimePickerModule, NgxMatTimepickerModule, NgxMatNativeDateModule } from '@angular-material-components/datetime-picker';
import {MatAutocompleteModule as MatAutocompleteModule } from '@angular/material/autocomplete';
import {MatButtonModule as MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import {MatCardModule as MatCardModule } from '@angular/material/card';
import {MatCheckboxModule as MatCheckboxModule } from '@angular/material/checkbox';
import {MatChipsModule as MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import {MatDialogModule as MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import {MatFormFieldModule as MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import {MatInputModule as MatInputModule } from '@angular/material/input';
import {MatListModule as MatListModule } from '@angular/material/list';
import {MatMenuModule as MatMenuModule } from '@angular/material/menu';
import {MatPaginatorModule as MatPaginatorModule } from '@angular/material/paginator';
import {MatProgressBarModule as MatProgressBarModule } from '@angular/material/progress-bar';
import {MatProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import {MatRadioModule as MatRadioModule } from '@angular/material/radio';
import {MatSelectModule as MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import {MatSlideToggleModule as MatSlideToggleModule } from '@angular/material/slide-toggle';
import {MatSliderModule as MatSliderModule } from '@angular/material/slider';
import {MatSnackBarModule as MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import {MatTableModule as MatTableModule } from '@angular/material/table';
import {MatTabsModule as MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import {MatTooltipModule as MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  declarations: [],
  exports: [
    MatNativeDateModule,
    MatListModule,
    MatSliderModule,
    MatAutocompleteModule,
    MatSnackBarModule,
    MatTreeModule,
    MatCheckboxModule,
    MatCheckboxModule,
    MatButtonModule,
    MatInputModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatRadioModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatMenuModule,
    MatSidenavModule,
    MatToolbarModule,
    MatGridListModule,
    MatCardModule,
    MatStepperModule,
    MatTabsModule,
    MatExpansionModule,
    MatButtonToggleModule,
    MatChipsModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatDialogModule,
    MatTooltipModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    NgxMatDatetimePickerModule,
    NgxMatTimepickerModule,
    NgxMatNativeDateModule
  ]
})
export class MaterialUtilitiesModule { }
